import { useEffect, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { routesHandler } from 'Checkout/Routes/routesHandler'
import { useValidateReservations } from 'Checkout/Hooks/useValidateReservations'
import { Button } from 'reactstrap'
import FontAwesomeIcon from 'Shared/FontAwesomeIcon/FontAwesomeIcon'
import Tooltip from 'Shared/Tooltip'

const TOOLTIP_TEXT = 'Complete each reservation in your cart before continuing to payment.'

const ContinuePaymentButton = () => {
  const { push } = useHistory()
  const clicked = useRef(false)
  const isPricingLoading = useSelector(state => state.cart.pricing.loading)
  const isValidationLoading = useSelector(state => state.cart.reservationsValidate.loading)
  const isReservationsInvalid = useSelector(state => !state.cart.reservationsValidate.data.valid)
  const validateReservations = useValidateReservations()
  const isDisabled = isPricingLoading || isReservationsInvalid || isValidationLoading

  const goToPayment = () => {
    clicked.current = true
    validateReservations()
  }

  useEffect(() => {
    if (clicked.current && !isValidationLoading && !isReservationsInvalid) {
      clicked.current = false
      push(routesHandler.payment.path)
    }
  }, [isValidationLoading])

  return (
    <div className="my-3" id="continue-payment-button">
      <Button className="w-100" color="theme-primary" disabled={isDisabled} onClick={goToPayment} size="lg">
        {isValidationLoading ? (
          <FontAwesomeIcon icon="spinner" size="sm" spin />
        ) : 'Continue to Payment'}
      </Button>

      {isReservationsInvalid && (
        <Tooltip idTarget="continue-payment-button" placement="bottom" value={TOOLTIP_TEXT} />
      )}
    </div>
  )
}

export default ContinuePaymentButton
